import address from '*/address.config.js';
// 引入filters
import '@/filters';
import messages from '@/lang';
// 引入公用方法，挂载到vue上
import utils from '@/utils';
import 'normalize.css';
import { Locale } from 'vant';
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Vuex from 'vuex';
import api from './api';
import App from './App.vue';
import bus from './eventBus';
import './plugins/axios';
import './plugins/sweet';
import './plugins/vant';
import wx from './plugins/wx';
import './assets/css/main.scss';
import router from './router';
import store from './store';
import QwCalendarSync from './plugins/QwCalendarSync';

// vant语言包对象，按需加载
const vantLang = {
  'en-US': enUS,
  'en': enUS,
  'en-GB': enUS,
  'zh-cn': zhCN,
  'zh-CN': zhCN,
}

// 国际化设置
Vue.use(VueI18n)

// 获取浏览器语言设置
var currentLang = navigator.language
if (!currentLang) {
  // 如果本地没有保存语言设置，则默认设置为中文简体
  currentLang = 'zh-CN'
  localStorage.setItem('currentLang', 'zh-CN')
}
// 根据当前语言加载vant语言包
if (currentLang !== 'zh-CN') {
  localStorage.setItem('currentLang', currentLang)
  Locale.use(currentLang, vantLang[currentLang] || enUS);
}
const i18n = new VueI18n({
  locale: currentLang,
  fallbackLocale: 'zh-CN',
  messages
})
window.i18n = i18n

window.address = address

Vue.prototype.$api = api
Vue.prototype.$utils = utils
Vue.prototype.$bus = bus
Vue.config.productionTip = false;
// 测试环境允许使用开发者工具
Vue.config.devtools = process.env.NODE_ENV === 'production' ? (process.env.VUE_APP_ENV === 'test' ? true : false) : true
Vue.use(Vuex)

let GeelyToken = localStorage.getItem('geelyToken')
const urlParams = utils.getUrlParams()
// 链接中带有ticket或者token参数
if (urlParams?.ticket || urlParams?.token) {
  console.log('用户中心单点登录')
  GeelyToken = urlParams.ticket || urlParams.token
  localStorage.setItem('geelyToken', GeelyToken)
  let toName = urlParams.name || ''
  let toEmail = urlParams.email || ''
  localStorage.setItem('ToAdd', 0)
  if (toEmail && toName) {
    localStorage.setItem('ToAdd', 1)
    localStorage.setItem('ToName', decodeURIComponent(decodeURIComponent(toName)))
    localStorage.setItem('ToEmail', decodeURIComponent(decodeURIComponent(toEmail)))
  }
  window.history.replaceState(null, null, location.origin)
}
if (GeelyToken) {
  api.user.getUserInfo().then((res) => {
    if (res?.Data) {
      store.commit('UPDATE_USER_INFO', res.Data)
      initApp()
    } else {
      utils.redirectToSSO(address)
    }
  })
} else {
  utils.redirectToSSO(address)
}

function initApp () {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app')
}
